<template>
    <div>
        <EditorBlock title="Static Page" :optional="true" :block="block">
            <input type="text" placeholder="/Pages/FL/content.html" class="w-100" v-model="block.src">
        </EditorBlock>
    </div>
</template>

<script>

import EditorBlock from "@/components/dashboard/storeadmin/EditorBlock";
export default {
    props: ['block'],
    components: {EditorBlock},
    methods: {
    },
}
</script>
